import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Input, Row } from 'reactstrap';
import debounce from 'lodash/debounce';

/**
 * TransactionFilter — transaction code / account number quick filters, meant
 * to sit in the table toolbar (TableContainer `toolbar` prop). Typing triggers
 * a debounced `onChangePagination(page, { transactionNumber | idNumber })`.
 */
const TransactionFilter = ({ pagination, onChangePagination = () => {} }) => {
  const [transactionNumber, setTransactionNumber] = useState('');
  const [idNumber, setIdNumber] = useState('');

  const search = useCallback(
    debounce((key, value) => {
      onChangePagination(
        { limit: pagination.pageSize, page: pagination.pageNumber },
        value ? { [key]: value } : {},
      );
    }, 600),
    [pagination, onChangePagination],
  );

  return (
    <Row className="g-2">
      <Col xs={6}>
        <Input
          name="transactionNumber"
          id="transactionNumber"
          placeholder="Transaction code"
          value={transactionNumber}
          onChange={(e) => {
            setTransactionNumber(e.target.value);
            search('transactionNumber', e.target.value.trim());
          }}
        />
      </Col>
      <Col xs={6}>
        <Input
          name="idNumber"
          id="idNumber"
          placeholder="Account number"
          value={idNumber}
          onChange={(e) => {
            setIdNumber(e.target.value);
            search('idNumber', e.target.value.trim());
          }}
        />
      </Col>
    </Row>
  );
};

TransactionFilter.propTypes = {
  pagination: PropTypes.object.isRequired,
  onChangePagination: PropTypes.func,
};

export default TransactionFilter;
